import React, { useState } from 'react'
import styles from './ContentConfirmation.module.css'
import { BasicInformation } from './BasicInformation'
import { UserWebResume } from './UserWebResume'
import { useAbTestGtm } from '../../../../../hooks/useAbTestGtm'

export const InputInformation = () => {
    const { dataClickLabel } = useAbTestGtm()
    const [isOpen, setIsOpen] = useState(false)

    const toggleAccordion = () => {
        setIsOpen(!isOpen)
    }

    return (
        <div className={styles.accordion}>
            <div>
                <button
                    className={styles.accordionHeader}
                    onClick={toggleAccordion}
                    aria-expanded={isOpen}
                    data-click-label={dataClickLabel(
                        'EF_StepForm_確認画面-入力情報'
                    )}
                >
                    {isOpen ? '入力情報を閉じる' : '入力情報をすべて表示'}
                </button>
                <div
                    className={`${styles.accordionContent} ${isOpen ? styles.open : ''}`}
                >
                    <BasicInformation />
                </div>
                <div
                    className={`${styles.accordionContent} ${isOpen ? styles.open : ''}`}
                >
                    <UserWebResume />
                </div>
            </div>
        </div>
    )
}
